module.exports = __webpack_public_path__ + "img/IMG_2248_FoamcoreMatted.a8aca612.jpg";